import React from 'react';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { useTranslation } from '@/src/i18n';
import { SPECIALITY_VACCINATION_CODE } from '@/src/constants';

type Props = {
  card: CardHcd;
  isLoadingAvailabilities: boolean;
};

const noAvailabilitiesText = {
  CENTER: 'no-rdv-with-center',
  PRACTITIONER_ONLINE: 'client-online-no-availabilities',
  PRACTITIONER_NO_ONLINE: 'client-no-online',
  [SPECIALITY_VACCINATION_CODE]: 'no-availabilities-vaccin-center',
};

const NoClientNoAvailability = ({ card, isLoadingAvailabilities }: Props) => {
  const { t } = useTranslation();
  const phoneNumber = card?.publicInformation?.officeInformation?.phoneNumber;
  const isCovidCenter =
    card?.type === 'CENTER' && card?.center?.isVaccinationPlace;
  const cardType = isCovidCenter ? SPECIALITY_VACCINATION_CODE : card?.type;
  let textType: keyof typeof noAvailabilitiesText = cardType as any;
  if (cardType === 'PRACTITIONER') {
    textType = card.settings?.isOnlineAppointment
      ? 'PRACTITIONER_ONLINE'
      : 'PRACTITIONER_NO_ONLINE';
  }

  if (isLoadingAvailabilities) return null;
  return (
    <div id="rdv" className="profile-content__rdv">
      <div className="rdv-form no-availabilities">
        <div className="rdv-form__title">
          <h4>{t('get-online-rdv')}</h4>
        </div>
        <div className="no-form" data-cy="no-availabilities">
          {card?.settings?.clientDocavenue && (
            <>
              <p className="info">{t(noAvailabilitiesText[textType])}</p>
              {(isCovidCenter || !card.settings.isOnlineAppointment) &&
                phoneNumber && (
                  <div className="rdv-phone">
                    <p>
                      {isCovidCenter
                        ? t('get-phone-rdv-covid-center')
                        : t('get-phone-rdv')}
                    </p>

                    <a className="phone" href={`tel:${phoneNumber}`}>
                      {phoneNumber}
                    </a>
                  </div>
                )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoClientNoAvailability;
